import { useEffect, useState } from 'react';

// When a watermarked PDF's link has been open too long (the server answers
// 403 with X-Linkjar-Reload: 1), offer a reload instead of a broken viewer.
// Viewers pass onPdfLoadError(documentUrl) to react-pdf's <Document onLoadError>;
// <ReloadNotice /> is rendered once by App.

const EVENT = 'linkjar:reload-needed';

export const onPdfLoadError = (url) => (error) => {
    // pdf.js reports HTTP failures with a status; only a 403 can be this case.
    if (!url || !error || error.status !== 403) return;
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then((res) => {
            if (res.status === 403 && res.headers.get('X-Linkjar-Reload') === '1') {
                window.dispatchEvent(new Event(EVENT));
            }
        })
        .catch(() => {});
};

const ReloadNotice = () => {
    const [shown, setShown] = useState(false);
    useEffect(() => {
        const show = () => setShown(true);
        window.addEventListener(EVENT, show);
        return () => window.removeEventListener(EVENT, show);
    }, []);
    if (!shown) return null;
    return (
        <div role="alert" style={{
            position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000,
            background: '#fff', color: '#0f172a', borderRadius: 14, padding: '20px 22px', maxWidth: 'calc(100vw - 32px)',
            width: 360, boxShadow: '0 12px 40px rgba(15,23,42,0.25)', fontFamily: 'system-ui, -apple-system, sans-serif',
            textAlign: 'center',
        }}>
            <p style={{ margin: 0, fontSize: 15, lineHeight: 1.5 }}>
                This link was open for a while. Reload to keep reading.
            </p>
            <button type="button" onClick={() => window.location.reload()} style={{
                marginTop: 14, background: '#2563eb', color: '#fff', border: 0, borderRadius: 10,
                padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
            }}>
                Reload
            </button>
        </div>
    );
};

export default ReloadNotice;
